// import React from 'react';
// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.fluent.my-little-fairies.css';
// // import 'devextreme/dist/css/dx.material.lime.light.css';
// import './css/styles.scss';

import React from 'react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.fluent.saas.light.css';
import './css/styles.css'


import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useScreenSizeClass } from './utils/media-query';
import Content from './layouts/content/Content';
// import { ThemeProvider } from '@mui/material/styles';
// import theme from './configs/theme';
import { ThemeContext, useThemeContext } from "./theme";
import { ToastProvider } from './components/ToastProvider';
import MainLayout from './layouts/MainLayout';

// 🔹 Import semua halaman public
import LoginPage from './pages/login/index';
import PenggunaanBarangIndex from './pages/mm/penggunaan-barang/index';
import PenggunaanBarangTambah from './pages/mm/penggunaan-barang/tambah-penggunaan/index';
import PenggunaanBarangDaftarProses from './pages/mm/penggunaan-barang/daftar-proses/index';
import PenggunaanBarangList from './pages/mm/penggunaan-barang/list-penggunaan/index';
import PenggunaanBarangJoblist from './pages/mm/penggunaan-barang/joblist/index';
import PenggunaanBarangEdit from './pages/mm/penggunaan-barang/edit-penggunaan/[id]';
import DashboardJoblist from './pages/dashboards/joblist/index';
import DashboardPermintaanGudang from './pages/dashboards/permintaan-gudang/index';

import ProductionInputProduksiDetail from './pages/production/input-produksi/[id]';
import ListInputProduksiIndex from './pages/production/input-produksi';
import ProductionInputProduksi17Index from './pages/production/input-produksi-17/index';
import KddInputProduksiIndex from './pages/kdd/input-produksi/index';
import ListPlanningProduksiIndex from './pages/production/planning-produksi';
import { ChatCustomerOmniIndex } from './pages';


interface RouteConfig {
  path: string;
  element: React.FC<any>;
}

const publicRoutes: RouteConfig[] = [
  { path: '/mm/penggunaan-barang', element: PenggunaanBarangIndex },
  { path: '/mm/penggunaan-barang/tambah-penggunaan', element: PenggunaanBarangTambah },
  { path: '/mm/penggunaan-barang/daftar-proses', element: PenggunaanBarangDaftarProses },
  { path: '/mm/penggunaan-barang/list-penggunaan', element: PenggunaanBarangList },
  { path: '/mm/penggunaan-barang/joblist', element: PenggunaanBarangJoblist },
  { path: '/mm/penggunaan-barang/edit-penggunaan/:id', element: PenggunaanBarangEdit },
  { path: '/dashboards/joblist', element: DashboardJoblist },
  { path: '/dashboards/permintaan-gudang', element: DashboardPermintaanGudang },
  { path: '/production/input-produksi/:id', element: ProductionInputProduksiDetail },
  { path: '/production/input-produksi', element: ListInputProduksiIndex },
  { path: '/production/input-produksi-17', element: ProductionInputProduksi17Index },
  { path: '/kdd/input-produksi', element: KddInputProduksiIndex },
  { path: '/omni/chat-customer', element:  ChatCustomerOmniIndex},
];

const nonLayout: RouteConfig[] = [
  { path: '/omni/chat-customer', element:  ChatCustomerOmniIndex}
];

const matchPath = (pattern: string, path: string): Record<string, string> | null => {
  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = path.split('/').filter(Boolean);

  if (patternParts.length !== pathParts.length) return null;

  const params: Record<string, string> = {};

  for (let i = 0; i < patternParts.length; i++) {
    const patternPart = patternParts[i];
    const pathPart = pathParts[i];

    if (patternPart.startsWith(':')) {
      const paramName = patternPart.slice(1);
      params[paramName] = pathPart;
    } else if (patternPart !== pathPart) {
      return null;
    }
  }

  return params;
};

const matchPublicRoute = (path: string): JSX.Element | null => {
  for (const route of publicRoutes) {
    const params = matchPath(route.path, path);
    if (params) {
      const Component = route.element;      
      return <Component {...params} routeParams={params.id} />;
    }
  }
  return null;
};

const matchNoLayoutRoute = (path: string): JSX.Element | null => {
  for (const route of nonLayout) {
    const params = matchPath(route.path, path);
    if (params) {
      const Component = route.element;      
      return <Component {...params} routeParams={params.id} />;
    }
  }
  return null;
};

const ProtectedRoute: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  const publicPage = matchPublicRoute(location.pathname);
  if (publicPage) {
    return <MainLayout>{publicPage}</MainLayout>;
  }

  const nonLayoutPage = matchNoLayoutRoute(location.pathname);
  if(nonLayoutPage && user){
    return <MainLayout>{nonLayoutPage}</MainLayout>;
  }

  if (user) return <Content />;

  return <LoginPage />;
};

const App: React.FC = () => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();

  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <AuthProvider>
          <NavigationProvider>
            <ToastProvider>
              <div className={`app ${screenSizeClass}`}>
                <ProtectedRoute />
              </div>
            </ToastProvider>
          </NavigationProvider>
        </AuthProvider>
      </ThemeContext.Provider>
    </Router>
  );
};

export default App;
